import React, {Component} from "react";
import {map, isEmpty} from "lodash";
import * as yup from "yup";
import {DatePicker, message} from "antd";
import moment from "moment-timezone";
import visa from "../../../../Assets/images/visa_dark.svg";
import american from "../../../../Assets/images/american_express_dark.svg";
import {errorHandle} from "../../../Common/errorHandle";
import {formatToCurrency} from "../../../../Tools/formatToCurrency";

const frequency_data = [
  {key: 'Twice Weekly', value: 'twice_weekly'},
  {key: 'Weekly', value: 'weekly'},
  {key: 'Every Other Week', value: 'bi_monthly'},
  {key: 'Monthly', value: 'monthly'},
  {key: 'One-Time', value: 'once'},
]

// mapping property type
const property_type = [
  {key: 'Town House', value: 'townhouse'},
  {key: 'Detached', comment: '<.5 acres. lot', value: 'single_family_small'},
  {key: 'Detached', comment: '>.5 acres. lot - FO to assess', value: 'single_family_large'},
]

const area_clean = [
  { key: 'Front Yard', value: 'front yard'},
  { key: 'Back Yard', value: 'back yard'},
  { key: 'Right Side', value: 'right side'},
  { key: 'Left Side', value: 'left side'},
  { key: 'Dog Run', value: 'dog run'},
  { key: 'Fenced Area', value: 'fenced area'},
  { key: 'Other', value: ''},
];

const last_cleaned = [
  { key: 'Less than 2 weeks', value: 'less_than_2_weeks'},
  { key: '2 to 6 weeks', value: '1-2_months'},
  { key: 'More than 6 weeks', value: '2_months_or_more'}
]

class SideBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      next_callback: '',
      purpose: '',
      notes: '',
      isApplyCoupon: false,
      coupon_code: '',
      couponCodeError: '',
      prepay_months: null,
      isPrePay: false,
      PricingCalcData: {},
      zipcodeCheck: false,
      errors: {},
      isLocalChange: false
    }
  }

  componentDidMount = () => {
    const { serviceOrderEnquiry } = this.props;
    this.props.getCallLogList({user__uuid: this.props.customerId, ordering: '-create_at', limit: 1, offset: 0}); // get call history
    if (serviceOrderEnquiry?.enquiryList?.count > 0) {
      this.setState({
        coupon_code: serviceOrderEnquiry?.enquiryList?.results[0]?.coupon_code, //calcData?.coupon_code,
        prepay_months: serviceOrderEnquiry?.enquiryList?.results[0]?.prepay_months, //calcData?.prepay_months,
        isPrePay: serviceOrderEnquiry?.enquiryList?.results[0]?.is_prepaid,
      });
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    const {enquiryList} = this.state;
    if(nextProps?.serviceOrderEnquiry?.enquiryList?.results?.length > 0 && JSON.stringify(nextProps?.serviceOrderEnquiry?.enquiryList?.results)!== JSON.stringify(enquiryList)){
      this.setState({
        enquiryList:nextProps?.serviceOrderEnquiry?.enquiryList?.results,
        coupon_code: nextProps?.serviceOrderEnquiry?.enquiryList?.results[0]?.coupon_code, //calcData?.coupon_code,
        prepay_months: nextProps?.serviceOrderEnquiry?.enquiryList?.results[0]?.prepay_months, //calcData?.prepay_months,
        isPrePay: nextProps?.serviceOrderEnquiry?.enquiryList?.results[0]?.is_prepaid,
      },()=> {
        const {coupon_code, prepay_months, isPrePay} = this.state;
        setTimeout(()=> {
          sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
          this.props.priceCalc({coupon_code, prepay_months, isPrePay})
        },2000)
        
      });
    }
    ////////////////// errors ///////////////////////////////////////
    if (Object.keys(nextProps?.CallLog?.errors).length > 0 && nextProps?.CallLog?.errors !== this.props?.CallLog?.errors) {
      this.setState({loader: false});
      errorHandle(nextProps?.CallLog?.errors)
    }
    ///////////////////////////////////////////////////////////////

    if (Object.keys(nextProps?.PricingCalc?.data).length > 0 && nextProps?.PricingCalc?.data !== this.props?.PricingCalc.data) {
      this.setState({couponCodeError: '', isApplyCoupon: false, coupon_code: '', coupon_applied: nextProps?.PricingCalc?.data?.coupon_applied})
    }

    if (nextProps?.zipcodeCheck && Object.keys(nextProps?.zipcodeCheck?.data).length > 0 && nextProps?.zipcodeCheck?.data?.results?.length > 0) {
      this.setState({zipcodeCheck: true, loader: false});
    } else {
      this.setState({zipcodeCheck: false, loader: false});
    }

    // get call logs
    if (Object.keys(nextProps?.CallLog?.logList).length > 0
      && JSON.stringify(nextProps?.CallLog?.logList) !== JSON.stringify(this.props?.CallLog?.logList)) {
      this.setState({next_callback: nextProps?.CallLog?.logList?.results?.[0]?.next_callback ? moment(nextProps?.CallLog?.logList?.results?.[0]?.next_callback) : undefined,
        purpose: nextProps?.CallLog?.logList?.results?.[0]?.reason,
        notes: nextProps?.CallLog?.logList?.results?.[0]?.notes,
      });
    }
  }

  // on service detail change
  onTextChange = (e, type, pricingCalc) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value, isLocalChange: true }, () => {
      const {coupon_code, prepay_months, isPrePay} = this.state;
      sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
      if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
      this.props.priceCalc({coupon_code, prepay_months, isPrePay})
    })
  }

  onTextChangePrepay = (e, type, pricingCalc) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    if (value) {
      this.setState({ [e.target.name]: value }, () => {
        const {coupon_code, prepay_months, isPrePay} = this.state;
        sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months, isPrePay}))
        if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
        this.props.priceCalc({coupon_code, prepay_months, isPrePay})
      })
    } else {
      this.setState({ [e.target.name]: value, prepay_months: null }, () => {
        const { coupon_code } = this.state;
        sessionStorage.setItem('calcData', JSON.stringify({coupon_code, prepay_months: null, isPrePay: false}))
        if (pricingCalc) sessionStorage.setItem('PricingCalc', JSON.stringify(pricingCalc))
        this.props.priceCalc({coupon_code, prepay_months: null, isPrePay: false})
      })
    }
  }

  // on lead detail change
  onLeadChange = (e, type) => {
    const value = type === 'bool' ? e.target.checked : e.target.value;
    this.setState({ [e.target.name]: value })
  }

  // validate required fields
  leadValidate = () => {
    const {next_callback, purpose, notes} = this.state;

    const schema = yup.object().shape({
      purpose: yup.string(),
      notes: yup.string(),
      next_callback: yup.string().nullable().test('match', 'Callback date is required', (next_callback) => {
        if (purpose || notes) return next_callback
        return true
      })
    });

    const data = {
      purpose,
      notes,
      next_callback,
    };

    return schema.validate(data, { abortEarly: false }).then(() => {
      this.setState({isLeadDetail: true, errors: {}});
      sessionStorage.setItem('logCall', JSON.stringify({next_callback, purpose, notes}))
      return Promise.resolve('success')
    }).catch((error) => {
      let err_data = {};
      map(error?.inner, (item) => {err_data[item.path] = item.message})
      this.setState({errors: err_data, isLeadDetail: false});
      return Promise.reject('fail')
    });
  };

  // render leads detail
  renderLeadsDetail = () => {
    const {next_callback, purpose, notes, errors} = this.state;
    return (
      <div className="acol mt-20">
        <h4>Save as a Lead? </h4>
        <div className="form-group">
          <div className="fitem half-fitem">
            <div className="fitem half-fitem">
              <label>Callback Date</label>
              <DatePicker
                id={"date"}
                name='next_callback'
                showTime
                minuteStep={15}
                use12Hours
                inputReadOnly
                placeholder={'Date'}
                format={"Do MMM, h:mm A"}
                value={next_callback ? moment(next_callback, 'Do MMM, h:mm A') : null}
                onChange={(e) => this.onLeadChange({target: {name: 'next_callback', value: e}})} />
              {errors?.[`next_callback`] ? <label className="new_err_msg"><i className="las la-info-circle"/>{errors?.[`next_callback`]}</label> : ''}
            </div>
            <div className="fitem half-fitem">
              <label>Purpose of Callback</label>
              <input
                id="purpose"
                name="purpose"
                type="text"
                placeholder={"Customer interested"}
                value={purpose || ''}
                onChange={(e) => this.onLeadChange(e)} />
            </div>
          </div>
          <div className="fitem">
            <label>Note</label>
            <textarea
              id="notes"
              name="notes"
              type="text"
              rows="4"
              placeholder={"Note"}
              value={notes || ''}
              onChange={(e) => this.onLeadChange(e)} />
          </div>
        </div>
      </div>
    )
  }
  
  renderSummary = () => {
    const {prepay_months, isPrePay} = this.state;
    const {PricingCalc} = this.props;
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const pricingCalc = JSON.parse(sessionStorage.getItem('pricingCalc'));
    const {frequency = '', propertyType = '', dogCount = '', lastCleaned = '', extra_pet = '', is_extra_pet = false, franchises = []} = step1Data || {};
    const PricingCalcData = PricingCalc?.data || pricingCalc || {};
    const frequencyValue = frequency_data.filter(obj => obj.value === frequency);
    const propertyValue = property_type.filter(obj => obj.value === propertyType);
    const diaplyLastCleanedValue = last_cleaned.filter(obj => obj.value === lastCleaned);
    const areaCleanValue = area_clean.filter(obj => PricingCalcData?.cleaning_areas?.items?.[0]?.area === obj.value);
    const isExistPricingData = Object.keys(PricingCalcData).length > 0;
    
    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="mb-20">Service Summary</h2>
          <h4>Subscription details</h4>
          {
            isExistPricingData &&
            <div className="flex">
              <div className="flex-1">
                <p>{`${frequencyValue?.[0]?.key || ''} service, ${areaCleanValue?.[0]?.key || ''} ${propertyValue?.[0]?.key || ''}  ${propertyValue?.[0]?.comment ? `(${propertyValue?.[0]?.comment})` : ''}`}</p>
                <p>{is_extra_pet ? `${extra_pet} dogs` : `${dogCount} ${dogCount === '1' ? 'Dog' : 'Dogs'}`}</p>
              </div>
              {isExistPricingData && <div className=""><b>${PricingCalcData?.service_base_price}</b></div>}
            </div>
          }
          <hr/>
          {
            map(PricingCalcData?.cleaning_areas?.items, (item, i) => {
              if (i !== 0) {
                return (
                  <div className="flex" key={`clean_area${i}`}>
                    <div className="flex-1" key={`cleaning_areas${i}`}>
                      <p>{item.area ? item.area : 'Other'}</p>
                    </div>
                    <div className=""><b>+${franchises?.[0]?.additional_cleaning_area_price ? franchises?.[0]?.additional_cleaning_area_price : '0'}</b></div>
                  </div>
                )
              }
            })
          }
          {map(PricingCalcData && PricingCalcData.recurring_add_ons && PricingCalcData.recurring_add_ons.recurring_addon_items, (item, i) => {
            if (item.type === 'add_on') {
              return (
                <div className="flex" key={`recurring_add_ons${i}`}>
                  <div className="flex-1">
                    <p>{item.name}</p>
                  </div>
                  <div className=""><b>+${item.price}</b></div>
                </div>
              )
            }
          })
          }
          <div className="highlight">
            <div className="flex">
              <div className="flex-1">
                {frequency === "once" ? <h4 className="m-0">Price for a single visit</h4> :
                  <h4 className="m-0">Price per {frequencyValue?.[0]?.key?.toLowerCase()} visit</h4> }
                {isExistPricingData ? <p>{`Billed ${frequency === 'once' ? 'Just Once' : 'Monthly'}`}</p> : <p />}
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_per_service}</b></div>}
            </div>
            <div className="flex">
              <div className="flex-1">
                <h4 className="m-0">Prepay and save up to 10%</h4>
              </div>
              <div className="chk_switch">
                <div className="can-toggle can-toggle--size-small">
                  <input className="fitem-ck-input" id="prepay_for_year" type="checkbox" name={"isPrePay"} checked={!isPrePay} onChange={(e) => { this.onTextChangePrepay({target: {name: 'isPrePay', value: !e.target.checked}}) }} />
                  <label htmlFor="prepay_for_year" className="fitem-ck-txt black">
                    <div className="can-toggle__switch"
                      data-unchecked="Yes"
                      data-checked="No"
                    />
                  </label>
                </div>
              </div>
            </div>
            {
              (isPrePay && isExistPricingData) && <div className="price_type">
                <div className="inline-check-list">
                  <div className="flex mt-10">
                    <div className="fitem-check mr-2"><input className="fitem-ck-input" id="6_month" checked={+prepay_months === 6} value="6" name="prepay_months" type="radio" onChange={(e) => this.onTextChange(e)} />
                      <label htmlFor="6_month" className="fitem-ck-txt">
                        Price for 6 months
                        <span> Save ${formatToCurrency(PricingCalcData?.prepay_price?.six_months?.savings)} (5%)</span>
                      </label>
                    </div>
                    <h3 className="price success">${formatToCurrency(PricingCalcData?.prepay_price?.six_months?.total_price_per_service)}</h3>
                  </div>
                  <div className={prepay_months === '12' || prepay_months === null ? 'flex mt-10' : 'flex mt-10 disble_sub_type'}>
                    <div className="fitem-check mr-2"><input className="fitem-ck-input" id="12_month" checked={+prepay_months === 12} value="12" name="prepay_months" type="radio" onChange={(e) => this.onTextChange(e)} />
                      <label htmlFor="12_month" className="fitem-ck-txt">
                        Price for 1 year
                        <span> Save ${formatToCurrency(PricingCalcData?.prepay_price?.twelve_months?.savings)} (10%)</span>
                      </label>
                    </div>
                    <h3 className="price success">${formatToCurrency(PricingCalcData?.prepay_price?.twelve_months?.total_price_per_service)}</h3>
                  </div>
                </div>
              </div>
            }
          </div>
          <div className="flex mt-30">
            <div className="flex-1">
              <h4 className="mb-0">One-time charge(s)</h4>
              {PricingCalcData.cleaning_areas ? map(PricingCalcData && PricingCalcData.one_time_charges && PricingCalcData.one_time_charges.one_time_items, (item, i) => {
                if (item.type === 'last_clean') {
                  const lastCleanedValue = last_cleaned.filter(obj => obj.value === item.name);
                  return <p key={`cleaning${i}`}>{lastCleanedValue?.[0]?.key} since last clean</p>
                }
                return <p key={`cleaning${i}`}>{item.name} since last clean</p>
              }) : isExistPricingData ? <p>{diaplyLastCleanedValue?.[0]?.key} since last clean</p> : ''
              }
            </div>
            {isExistPricingData && <div className=""><b>+${PricingCalcData?.one_time_charges?.total_one_time_charge}</b></div>}
          </div>
          <div className="wlight">
            <div className="flex ai-center">
              <div className="flex-1">
                <h4 className="m-0">Total for first visit</h4>
              </div>
              {isExistPricingData && +prepay_months === 6 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.six_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && +prepay_months === 12 && <div className="pricing"><b>+${PricingCalcData?.prepay_price?.twelve_months?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
              {isExistPricingData && !isPrePay && !prepay_months && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
            </div>
          </div>
          
          {!isEmpty(PricingCalcData?.coupon?.coupon_applied) ?<div className="">
            <div className="flex">
              <div className="flex-1">
                <h4 className="m-0">Coupon</h4>
                <p>{PricingCalcData?.coupon?.coupon_applied}</p>
              </div>
              <div className="pricing"><b>{PricingCalcData?.coupon?.savings ? `-$${PricingCalcData?.coupon?.savings}` : '$0'}</b></div>
            </div>
          </div>
            : ''}
        </div>
        {this.renderLeadsDetail()}
      </div>
    );
  }

  renderConfirmation = () => {
    const {PricingCalc, cardDetail} = this.props;
    const basicDetail = JSON.parse(sessionStorage.getItem('basicDetail'));
    const step1Data = JSON.parse(sessionStorage.getItem('step1'));
    const step2Data = JSON.parse(sessionStorage.getItem('step2'));
    const pricingCalc = JSON.parse(sessionStorage.getItem('pricingCalc'));
    const {frequency = '', propertyType = '', dogCount = '', lastCleaned = ''} = step1Data || {};
    const PricingCalcData = PricingCalc?.data || pricingCalc || {};
    const frequencyValue = frequency_data.filter(obj => obj.value === frequency);
    const propertyValue = property_type.filter(obj => obj.value === propertyType);
    const diaplyLastCleanedValue = last_cleaned.filter(obj => obj.value === lastCleaned);
    const areaCleanValue = area_clean.filter(obj => PricingCalcData?.cleaning_areas?.items?.[0]?.area === obj.value);
    const isExistPricingData = Object.keys(PricingCalcData).length > 0;
    const billing_address = step2Data?.isBillingAddress ? basicDetail?.address : step2Data?.address;
    let addressStr = (billing_address?.street_number || billing_address?.route) ? `${step2Data?.address?.street_number || ''} ${step2Data?.address?.route || ''}` : billing_address?.address;
    addressStr += billing_address?.city ? `, ${billing_address?.city}` : '';
    addressStr += billing_address?.state ? `, ${billing_address?.state}` : '';
    addressStr += billing_address?.zip_code ? `, ${billing_address?.zip_code}` : '';

    return (
      <div className="aside-bar">
        <div className="acol">
          <h2 className="mb-20">Your service confirmed!</h2>
          <h4>Billing details</h4>
          <div className={"d-block"}>
            <div className="card_img flex ai-center flex-start">
              {cardDetail?.stripe_card_details?.brand === 'visa' ?
                <img src={visa} alt="" /> :
                <img src={american} alt="" />} &nbsp;&nbsp;
              <label className="m-0">{`${cardDetail?.stripe_card_details?.brand} ending in ${cardDetail?.stripe_card_details?.last4}`}</label>
            </div>
            <p className="mt-10">{addressStr}</p>
          </div>
          <hr/>
          <h4>Subscription details</h4>
          {
            isExistPricingData &&
            <div className="flex">
              <div className="flex-1">
                <p>{`${frequencyValue?.[0]?.key} service, ${areaCleanValue?.[0]?.key} ${propertyValue?.[0]?.key}  ${propertyValue?.[0]?.comment ? `(${propertyValue?.[0]?.comment})` : ''}`}</p>
                <p>{`${dogCount} ${dogCount === '1' ? 'Dog' : 'Dogs'}`}</p>
              </div>
              {isExistPricingData && <div className=""><b>${PricingCalcData?.service_base_price}</b></div>}
            </div>
          }
          <hr/>
          {
            map(PricingCalcData?.cleaning_areas?.items, (item, i) => {
              if (i !== 0) {
                return (
                  <div className="flex">
                    <div className="flex-1" key={`cleaning_areas${i}`}>
                      <p>{item.area ? item.area : 'Other'}</p>
                    </div>
                    <div className=""><b>+${item.price}</b></div>
                  </div>
                )
              }
            })
          }
          {map(PricingCalcData && PricingCalcData.recurring_add_ons && PricingCalcData.recurring_add_ons.recurring_addon_items, (item, i) => {
            if (item.type === 'add_on') {
              return (
                <div className="flex" key={`recurring_add_ons${i}`}>
                  <div className="flex-1">
                    <p>{item.name}</p>
                  </div>
                  <div className=""><b>+${item.price}</b></div>
                </div>
              )
            }
          })
          }
          <div className="highlight">
            <div className="flex">
              <div className="flex-1">
                {frequency === "once" ? <h4 className="m-0">Price for a single visit</h4> :
                  <h4 className="m-0">Price per {frequencyValue?.[0]?.key?.toLowerCase()} visit</h4> }
                <p>{`Billed ${frequency === 'once' ? 'Just Once' : 'Monthly'}`}</p>
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_per_service}</b></div>}
            </div>
          </div>
          <div className="flex mt-30">
            <div className="flex-1">
              <h4 className="mb-0">One-time charge(s)</h4>
              {PricingCalcData.cleaning_areas ? map(PricingCalcData && PricingCalcData.one_time_charges && PricingCalcData.one_time_charges.one_time_items, (item, i) => {
                if (item.type === 'last_clean') {
                  const lastCleanedValue = last_cleaned.filter(obj => obj.value === item.name);
                  return <p key={`cleaning${i}`}>{lastCleanedValue?.[0]?.key} since last clean</p>
                }
                return <p key={`cleaning${i}`}>{item.name} since last clean</p>
              }) : <p>{diaplyLastCleanedValue?.[0]?.key} since last clean</p>
              }
            </div>
            {isExistPricingData && <div className=""><b>+${PricingCalcData?.one_time_charges?.total_one_time_charge}</b></div>}
          </div>
          <div className="wlight">
            <div className="flex ai-center">
              <div className="flex-1">
                <h4 className="m-0">Total for first visit</h4>
              </div>
              {isExistPricingData && <div className="pricing"><b>+${PricingCalcData?.total_price_for_first_visit}</b></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {currentTab} = this.props;

    if (currentTab === 2) {
      return this.renderConfirmation()
    } else {
      return this.renderSummary()
    }
  }
}

export default SideBar;
